export class Wrapper<T> {
    constructor(protected inner: T) {}

    then<E>(f: (t: T) => E): Wrapper<E> {
        return wrap(f(this.inner));
    }

    take<F extends (it: T) => unknown>(fn: F): ReturnType<F>;
    take(): T;

    take<E = T>(mapping?: (it: T) => E): T | E {
        return typeof mapping == "function" ? mapping(this.inner) : this.inner;
    }
}

export function wrap<T>(inner: T): Wrapper<T> {
    return new Wrapper(inner);
}
